"use strict";

import React, { Component } from "react";
import PropTypes from "prop-types";

import ReactDOM from "react-dom";
import classNames from "classnames";
import { isNumberKeyFromEvent, getIntegerFromEvent } from "../../utilities/EventsHelper";

import LockIcon from "../../controls/LockIcon.jsx";
import PasswordPolicy from "newApp/entities/PasswordPolicy";
import SettingsLocks from "newApp/entities/SettingsLocks";
import SettingsValidationObject from "newApp/entities/SettingsValidaionObject";

export class PasswordSettings extends React.Component {
    constructor (props) {
        super(props);

        this._handleMaximumAgeChange = this._handleMaximumAgeChange.bind(this);

        this._handleMaximumAgeKeyPress = this._handleMaximumAgeKeyPress.bind(this);
        this._handleMinimumLengthChange = this._handleMinimumLengthChange.bind(this);
        this._handleMinimumLengthKeyPress = this._handleMinimumLengthKeyPress.bind(this);

        this._handleRequireAlphabeticalCharactersClick = this._handleRequireAlphabeticalCharactersClick.bind(this);

        this._handleAlphabeticalCharactersNumberChange = this._handleAlphabeticalCharactersNumberChange.bind(this);
        this._handleAlphabeticalCharactersNumberKeyPress = this._handleAlphabeticalCharactersNumberKeyPress.bind(this);

        this._handleRequireUppercaseCharactersClick = this._handleRequireUppercaseCharactersClick.bind(this);
        this._handleUppercaseCharactersNumberChange = this._handleUppercaseCharactersNumberChange.bind(this);
        this._handleUppercaseCharactersNumberKeyPress = this._handleUppercaseCharactersNumberKeyPress.bind(this);

        this._handleRequireLowercaseCharactersClick = this._handleRequireLowercaseCharactersClick.bind(this);
        this._handleLowercaseCharactersNumberChange = this._handleLowercaseCharactersNumberChange.bind(this);

        this._handleLowercaseCharactersNumberKeyPress = this._handleLowercaseCharactersNumberKeyPress.bind(this);

        this._handleRequireNumericCharactersClick = this._handleRequireNumericCharactersClick.bind(this);
        this._handleNumericCharactersNumberChange = this._handleNumericCharactersNumberChange.bind(this);
        this._handleNumericCharactersNumberKeyPress = this._handleNumericCharactersNumberKeyPress.bind(this);
        this._handleRequirePunctuationOrOtherCharactersClick = this._handleRequirePunctuationOrOtherCharactersClick.bind(this);
        this._handlePunctuationOrOtherCharactersNumberChange = this._handlePunctuationOrOtherCharactersNumberChange.bind(this);
        this._handlePunctuationOrOtherCharactersNumberKeyPress = this._handlePunctuationOrOtherCharactersNumberKeyPress.bind(this);

        this._isFocused = this._isFocused.bind(this);
    }

    render () {
        const classNameMaximumAgeRange = classNames("alert", "alert-danger", { "hidden": this.props.validationObject.maximumAge.rangeRule.isValid });
        const classNameMinimumLengthRange = classNames("alert", "alert-danger", { "hidden": this.props.validationObject.minimumLength.rangeRule.isValid });
        const classNameMinimumLength = classNames("alert", "alert-danger", { "hidden": this.props.validationObject.minimumLength.sumOfFieldsRule.isValid });
        const classNameAlphabeticalCharacters = classNames("alert", "alert-danger", { "hidden": this.props.validationObject.alphabeticalCharacters.sumOfFieldsRule.isValid });

        return (
            <div id="PasswordSettings">
                <h4>Password Settings</h4>
                <div className="horizontal-line"/>
                <div className="control-row">
                    <div className="formControlTitle">Days Valid</div>
                    <input className="picker-hollow textbox"
                        id="maximumAge"
                        maxLength="3"
                        onChange={this._handleMaximumAgeChange}
                        onKeyPress={this._handleMaximumAgeKeyPress}
                        tabIndex="0"
                        type="text"
                        value={this.props.passwordPolicy.maximumAge}
                        disabled={this.props.settingsLocks.maximumAge}
                    />
                    <LockIcon isLocked={this.props.settingsLocks.maximumAge}/>

                    <div className={classNameMaximumAgeRange} id="maximumAgeRangeErrorMessage">
                        Password valid days should be greater than 0
                    </div>
                </div>


                <div className="control-row">
                    <div className="formControlTitle">Minimum Length</div>
                    <input className="picker-hollow textbox"
                        id="minimumLength"
                        maxLength="3"
                        onChange={this._handleMinimumLengthChange}
                        onKeyPress={this._handleMinimumLengthKeyPress}
                        tabIndex="0"
                        type="text"
                        value={this.props.passwordPolicy.minimumLength}
                        disabled={this.props.settingsLocks.minimumLength}
                    />
                    <LockIcon isLocked={this.props.settingsLocks.minimumLength}/>

                    <div className={classNameMinimumLength} id="minimumPasswordLengthErrorMessage">
                        Sum of child fields exceeds minimum password length
                    </div>

                    <div className={classNameMinimumLengthRange} id="minimumPasswordLengthRangeErrorMessage">
                        Minimum password length should be at least 8 and no more than 25
                    </div>
                </div>

                <div className="control-row">
                    <div className="checkbox checkbox-primary" id="requireAlphabeticalCharacters">
                        <label>
                            <input id="cbRequireAlphabeticalCharacters"
                                checked={this.props.passwordPolicy.alphabeticalCharacters.required}
                                disabled={this.props.settingsLocks.alphabeticalCharacters}
                                onClick={this._handleRequireAlphabeticalCharactersClick}
                                tabIndex="-1"
                                type="checkbox"/>

                            <CheckBoxIcon/>

                            <div className="formControlTitle"
                                style={{ display: "inline-block", marginLeft: "10px", marginTop: "5px" }}>
                                <span>Require Alphabetical Letters</span>
                            </div>
                            <LockIcon isLocked={this.props.settingsLocks.alphabeticalCharacters}/>
                        </label>

                        <div id="alphabeticalCharactersGroup"
                            className={!this.props.passwordPolicy.alphabeticalCharacters.required ? "hidden" : ""}>
                            <input className="picker-hollow textbox"
                                id="alphabeticalCharactersNumber"
                                maxLength="3"
                                onChange={this._handleAlphabeticalCharactersNumberChange}
                                onKeyPress={this._handleAlphabeticalCharactersNumberKeyPress}
                                ref={(c) => this.alphabeticalCharactersNumber = c}
                                tabIndex="0"
                                type="text"
                                value={this.props.passwordPolicy.alphabeticalCharacters.number}
                                disabled={this.props.settingsLocks.alphabeticalCharacters}
                            />

                            <div className={classNameAlphabeticalCharacters} id="alphabeticalCharactersErrorMessage">
                                Sum of child fields exceeds minimum alphabetical letters number
                            </div>

                            <div className="control-row">
                                <div className="checkbox checkbox-primary" id="requireUppercaseCharacters">
                                    <label>
                                        <input id="cbRequireUppercaseCharacters"
                                            checked={this.props.passwordPolicy.alphabeticalCharacters.uppercaseCharacters.required}
                                            disabled={this.props.settingsLocks.uppercaseCharacters}
                                            onClick={this._handleRequireUppercaseCharactersClick}
                                            tabIndex="-1"
                                            type="checkbox"/>

                                        <CheckBoxIcon/>

                                        <div className="formControlTitle"
                                            style={{ display: "inline-block", marginLeft: "10px" }}>
                                            <span>Require Capital Letters</span>
                                        </div>
                                        <LockIcon isLocked={this.props.settingsLocks.uppercaseCharacters}/>
                                    </label>

                                    <div id="uppercaseCharactersGroup"
                                        className={!this.props.passwordPolicy.alphabeticalCharacters.uppercaseCharacters.required ? "hidden" : ""}>
                                        <input className="picker-hollow textbox"
                                            id="uppercaseCharactersNumber"
                                            maxLength="3"
                                            onChange={this._handleUppercaseCharactersNumberChange}
                                            onKeyPress={this._handleUppercaseCharactersNumberKeyPress}
                                            ref={(c) => this.uppercaseCharactersNumber = c}
                                            tabIndex="0"
                                            type="text"
                                            value={this.props.passwordPolicy.alphabeticalCharacters.uppercaseCharacters.number}
                                            disabled={this.props.settingsLocks.uppercaseCharacters}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="control-row">
                                <div className="checkbox checkbox-primary" id="requireLowercaseCharacters">
                                    <label>
                                        <input id="cbRequireLowercaseCharacters"
                                            checked={this.props.passwordPolicy.alphabeticalCharacters.lowercaseCharacters.required}
                                            disabled={this.props.settingsLocks.lowercaseCharacters}
                                            onClick={this._handleRequireLowercaseCharactersClick}
                                            tabIndex="-1"
                                            type="checkbox"/>

                                        <CheckBoxIcon/>

                                        <div className="formControlTitle"
                                            style={{ display: "inline-block", marginLeft: "10px" }}>
                                            <span>Require Lowercase Letters</span>
                                        </div>
                                        <LockIcon isLocked={this.props.settingsLocks.lowercaseCharacters}/>
                                    </label>
                                    <div id="lowercaseCharactersGroup"
                                        className={!this.props.passwordPolicy.alphabeticalCharacters.lowercaseCharacters.required ? "hidden" : ""}>
                                        <input className="picker-hollow textbox"
                                            id="lowercaseCharactersNumber"
                                            maxLength="3"
                                            onChange={this._handleLowercaseCharactersNumberChange}
                                            onKeyPress={this._handleLowercaseCharactersNumberKeyPress}
                                            ref={(c) => this.lowercaseCharactersNumber = c}
                                            tabIndex="0"
                                            type="text"
                                            value={this.props.passwordPolicy.alphabeticalCharacters.lowercaseCharacters.number}
                                            disabled={this.props.settingsLocks.lowercaseCharacters}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="control-row">
                    <div className="checkbox checkbox-primary" id="requireNumericCharacters">
                        <label>
                            <input id="cbRequireNumericCharacters"
                                checked={this.props.passwordPolicy.numericCharacters.required}
                                disabled={this.props.settingsLocks.numericCharacters}
                                onClick={this._handleRequireNumericCharactersClick}
                                tabIndex="-1"
                                type="checkbox"/>

                            <CheckBoxIcon/>

                            <div className="formControlTitle" style={{ display: "inline-block", marginLeft: "10px" }}>
                                <span>Require Numbers</span>
                            </div>
                            <LockIcon isLocked={this.props.settingsLocks.numericCharacters}/>
                        </label>
                        <div id="numericCharactersGroup"
                            className={!this.props.passwordPolicy.numericCharacters.required ? "hidden" : ""}>
                            <input className="picker-hollow textbox"
                                id="numericCharactersNumber"
                                maxLength="3"
                                onChange={this._handleNumericCharactersNumberChange}
                                onKeyPress={this._handleNumericCharactersNumberKeyPress}
                                ref={(c) => this.numericCharactersNumber = c}
                                tabIndex="0"
                                type="text"
                                value={this.props.passwordPolicy.numericCharacters.number}
                                disabled={this.props.settingsLocks.numericCharacters}
                            />
                        </div>
                    </div>
                </div>

                <div className="control-row">
                    <div className="checkbox checkbox-primary" id="requirePunctuationOrOtherCharacters">
                        <label>
                            <input id="cbRequirePunctuationOrOtherCharacters"
                                checked={this.props.passwordPolicy.punctuationOrOtherCharacters.required}
                                disabled={this.props.settingsLocks.punctuationOrOtherCharacters}
                                onClick={this._handleRequirePunctuationOrOtherCharactersClick}
                                tabIndex="-1"
                                type="checkbox"/>

                            <CheckBoxIcon/>

                            <div className="formControlTitle" style={{ display: "inline-block", marginLeft: "10px" }}>
                                <span>Require Special Characters</span>
                            </div>
                            <LockIcon isLocked={this.props.settingsLocks.punctuationOrOtherCharacters}/>
                        </label>

                        <div id="punctuationOrOtherCharactersGroup" className={!this.props.passwordPolicy.punctuationOrOtherCharacters.required ? "hidden" : ""}>
                            <input className="picker-hollow textbox"
                                id="punctuationOrOtherCharactersNumber"
                                maxLength="3"
                                onChange={this._handlePunctuationOrOtherCharactersNumberChange}
                                onKeyPress={this._handlePunctuationOrOtherCharactersNumberKeyPress}
                                ref={(c) => this.punctuationOrOtherCharactersNumber = c}
                                tabIndex="0"
                                type="text"
                                value={this.props.passwordPolicy.punctuationOrOtherCharacters.number}
                                disabled={this.props.settingsLocks.punctuationOrOtherCharacters}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    _handleMaximumAgeChange (e) {
        const age = getIntegerFromEvent(e);
        this.props.setPasswordMaximumAge(age);
    }

    _handleMaximumAgeKeyPress (e) {
        if (!isNumberKeyFromEvent(e)) {
            e.preventDefault();
        }
    }

    _handleMinimumLengthChange (e) {
        const length = getIntegerFromEvent(e);
        this.props.setPasswordMinimumLength(length);
    }

    _handleMinimumLengthKeyPress (e) {
        if (!isNumberKeyFromEvent(e)) {
            e.preventDefault();
        }
    }

    _handleRequireAlphabeticalCharactersClick (e) {
        this.props.allowPasswordAlphabeticalCharacters(e.target.checked);

        if (e.target.checked) {
            this._setFocus(this.alphabeticalCharactersNumber);
        }
    }

    _handleAlphabeticalCharactersNumberChange (e) {
        const number = getIntegerFromEvent(e);
        this.props.setPasswordAlphabeticalCharactersNumber(number);
    }


    _handleAlphabeticalCharactersNumberKeyPress (e) {
        if (!isNumberKeyFromEvent(e)) {
            e.preventDefault();
        }
    }

    _handleRequireUppercaseCharactersClick (e) {
        this.props.allowPasswordUppercaseCharacters(e.target.checked);

        if (e.target.checked) {
            this._setFocus(this.uppercaseCharactersNumber);
        }
    }

    _handleUppercaseCharactersNumberChange (e) {
        const number = getIntegerFromEvent(e);
        this.props.setPasswordUppercaseCharactersNumber(number);
    }

    _handleUppercaseCharactersNumberKeyPress (e) {
        if (!isNumberKeyFromEvent(e)) {
            e.preventDefault();
        }
    }

    _handleRequireLowercaseCharactersClick (e) {
        this.props.allowPasswordLowercaseCharacters(e.target.checked);

        if (e.target.checked) {
            this._setFocus(this.lowercaseCharactersNumber);
        }
    }

    _handleLowercaseCharactersNumberChange (e) {
        const number = getIntegerFromEvent(e);
        this.props.setPasswordLowercaseCharactersNumber(number);
    }

    _handleLowercaseCharactersNumberKeyPress (e) {
        if (!isNumberKeyFromEvent(e)) {
            e.preventDefault();
        }
    }

    _handleRequireNumericCharactersClick (e) {
        this.props.allowPasswordNumericCharacters(e.target.checked);

        if (e.target.checked) {
            this._setFocus(this.numericCharactersNumber);
        }
    }

    _handleNumericCharactersNumberChange (e) {
        const number = getIntegerFromEvent(e);
        this.props.setPasswordNumericCharactersNumber(number);
    }

    _handleNumericCharactersNumberKeyPress (e) {
        if (!isNumberKeyFromEvent(e)) {
            e.preventDefault();
        }
    }

    _handleRequirePunctuationOrOtherCharactersClick (e) {
        this.props.allowPasswordPunctuationOrOtherCharacters(e.target.checked);

        if (e.target.checked) {
            this._setFocus(this.punctuationOrOtherCharactersNumber);
        }
    }

    _handlePunctuationOrOtherCharactersNumberChange (e) {
        const number = getIntegerFromEvent(e);
        this.props.setPasswordPunctuationOrOtherCharactersNumber(number);
    }

    _handlePunctuationOrOtherCharactersNumberKeyPress (e) {
        if (!isNumberKeyFromEvent(e)) {
            e.preventDefault();
        }
    }

    _setFocus (element) {
        setTimeout(() => {
            if (ReactDOM.findDOMNode(element).focusedElement) {
                ReactDOM.findDOMNode(element).focusedElement.focus();
            }
        }, 0);
    }

    _isFocused (id) {
        const currentElement = document.getElementById(id);
        return currentElement == document.activeElement;
    }
}

const CheckBoxIcon = () => (
    <span className="checkbox-material">
        <span className="check" />
    </span>);

PasswordSettings.propTypes = {
    passwordPolicy: PropTypes.instanceOf(PasswordPolicy).isRequired,
    settingsLocks: PropTypes.instanceOf(SettingsLocks).isRequired,
    setPasswordPunctuationOrOtherCharactersNumber: PropTypes.func,
    allowPasswordPunctuationOrOtherCharacters: PropTypes.func,
    setPasswordMaximumAge: PropTypes.func,
    setPasswordMinimumLength: PropTypes.func,
    allowPasswordAlphabeticalCharacters: PropTypes.func,
    setPasswordAlphabeticalCharactersNumber: PropTypes.func,
    setPasswordNumericCharactersNumber: PropTypes.func,
    allowPasswordUppercaseCharacters: PropTypes.func,
    allowPasswordNumericCharacters: PropTypes.func,
    setPasswordUppercaseCharactersNumber: PropTypes.func,
    validationObject: PropTypes.instanceOf(SettingsValidationObject).isRequired
};

export default PasswordSettings;

